__turbopack_context__.v({
  "messagesButton": "MessagesButton-module__0NKJWG__messagesButton",
});
